import DepsService from 'services/dependencies';
import { SELECTED_USERS } from 'message/components/create-message/create-message-component';

const CONTEXT = 'message';

export const fetchMessagesList = async (queryParams) => {
  const { url } = DepsService.rest.message.user.inbox;

  return DepsService.restSrv.list(CONTEXT, url, queryParams);
};

export const fetchUserSentMessagesList = async (queryParams) => {
  const { url } = DepsService.rest.message.user.sent;

  return DepsService.restSrv.list(CONTEXT, url, queryParams);
};

export const fetchMessage = async (id) => {
  const { url } = DepsService.rest.message.user.content;
  const queryParams = {};
  const urlParams = { id };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchUnreadMessagesCount = async () => {
  const { url } = DepsService.rest.message.user.count;

  return DepsService.restSrv.list(CONTEXT, url);
};

export const deleteReceivedMessages = async (data) => {
  const { url } = DepsService.rest.message.delete.received;
  const urlParams = {};

  return DepsService.restSrv.remove(CONTEXT, url, urlParams, { data });
};

export const deleteSentMessages = async (data) => {
  const { url } = DepsService.rest.message.delete.sent;
  const urlParams = {};

  return DepsService.restSrv.remove(CONTEXT, url, urlParams, { data });
};

export const markMessageAsUnread = async (id) => {
  const { url } = DepsService.rest.message.user.markAsUnread;
  const queryParams = {};
  const urlParams = { id };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const markMessageAsRead = async (id) => {
  const { url } = DepsService.rest.message.user.markAsRead;
  const queryParams = {};
  const urlParams = { id };

  return DepsService.restSrv.update(CONTEXT, url, queryParams, urlParams);
};

export const fetchSentMessagesList = async (queryParams) => {
  const { url } = DepsService.rest.message.admin.sent;

  return DepsService.restSrv.list(CONTEXT, url, queryParams);
};

export const fetchSentMessage = async (id) => {
  const { url } = DepsService.rest.message.admin.content;
  const queryParams = {};
  const urlParams = { id };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const fetchAdministratorsSentMessagesList = async (queryParams) => {
  const { url } = DepsService.rest.message.admin.sentByAll;

  return DepsService.restSrv.list(CONTEXT, url, queryParams);
};

export const fetchRecipients = async ({ filters, ...params }) => {
  const { url } = DepsService.rest.message.admin.recipients;
  const { sentMessageId, ...requestFilters } = filters;
  const queryParams = { ...params, ...requestFilters };
  const urlParams = { id: sentMessageId };

  return DepsService.restSrv.list(CONTEXT, url, queryParams, urlParams);
};

export const createMessageLimitToRetailers = async (message) => {
  const { url } = DepsService.rest.message.admin.createLimitToRetailers;
  return DepsService.restSrv.create(CONTEXT, url, message);
};

export const createMessage = async (message) => {
  const { url } = DepsService.rest.message.admin.create;
  return DepsService.restSrv.create(CONTEXT, url, message);
};

export const replyMessage = async (message) => {
  const { url } = DepsService.rest.message.reply;

  const payload = {
    recipientCategoryCode: SELECTED_USERS,
    ...message,
  };

  return DepsService.restSrv.create(CONTEXT, url, payload);
};



// WEBPACK FOOTER //
// ./src/modules/message/resources/message.api.js